import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Dashboard.module.css';
import HotelProLogo from '../assets/images/hotel-pro-logo.png';

const sidebarItems = [
  {
    label: 'Dashboard',
    path: '/dashboard',
    icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/e686add4bbf0f5075db7ffa88f75f8971e8dd6ae57a537437fdde57287661f80',
    allowedRoles: ['manager', 'housekeeping'], // Added 'manager' and 'reception'
  },
  {
    label: 'Booking',
    path: '/booking',
    icon: 'images/key.svg',
    allowedRoles: ['manager'],
  },
  {
    label: 'Front Desk',
    path: null,
    icon: '/images/front-icon.svg',
    allowedRoles: ['manager', 'reception'],
    dropdown: [
      {
        label: 'Check Availability',
        path: '/frontdesk',
        icon: '/images/check-icon.svg',
        allowedRoles: ['manager', 'reception'], // Added 'reception'
      },
      {
        label: 'Guests',
        path: '/guest',
        icon: '/images/guest-icon.svg',
        allowedRoles: ['reception'],
      },
      {
        label: 'Documents',
        path: '/documents',
        icon: 'images/documents-icon.svg',
        allowedRoles: ['manager'],
      },
      /* {
        label: 'Hotel Details',
        path: '/hotel-details',
        icon: 'images/notebook-tabs.svg',
        allowedRoles: ['manager'],
      }, */
    ],
  },
  {
    label: 'F & B',
    path: '',
    icon: '/images/f&bs-icon.svg',
    allowedRoles: ['manager'],
    dropdown: [
      {
        label: 'Inventory',
        path: '/inventory',
        icon: '/images/inventory-icon.svg',
        allowedRoles: ['manager'],
      },
      {
        label: 'Room Orders',
        path: '/room-orders',
        icon: '/images/room-icon.svg',
        allowedRoles: ['manager'],
      },
    ],
  },
  {
    label: 'House Keeping',
    icon: '/images/house-icon.svg',
    allowedRoles: ['housekeeping'],
    dropdown: [
      {
        label: 'Rooms',
        path: '/room',
        icon: '/images/room-icon.svg',
        allowedRoles: ['housekeeping'],
      },
    ],
  },
];

export const Sidebar = () => {
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState(window.location.pathname);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 884);
  const [isLargerScreen, setIsLargerScreen] = useState(window.innerWidth > 884);

  // Get the user's role from localStorage
  const role = localStorage.getItem('role');

  useEffect(() => {
    const handleResize = () => {
      const isLarge = window.innerWidth > 884;
      setIsLargerScreen(isLarge);
      setIsSidebarOpen(isLarge); // Keep sidebar open for larger screens
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Keep dropdown open if an active item belongs to it
  useEffect(() => {
    sidebarItems.forEach(item => {
      if (item.dropdown) {
        const isActive = item.dropdown.some(
          subItem => subItem.path === activeItem
        );
        if (isActive) {
          setOpenDropdown(item.label);
        }
      }
    });
  }, [activeItem]);

  const handleClick = item => {
    setActiveItem(item.path);

    if (item.dropdown) {
      setOpenDropdown(openDropdown === item.label ? null : item.label);
    } else {
      setOpenDropdown(null); // Close dropdown only when a non-dropdown item is clicked
      navigate(item.path);
    }
  };

  return (
    <>
      {!isLargerScreen && (
        <div
          className={styles.toggleContainer}
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          <div className={styles.hamburger}>
            <div
              className={`${styles.bar} ${isSidebarOpen ? styles.open : ''}`}
            />
            <div
              className={`${styles.bar} ${isSidebarOpen ? styles.open : ''}`}
            />
            <div
              className={`${styles.bar} ${isSidebarOpen ? styles.open : ''}`}
            />
          </div>
        </div>
      )}

      <div
        className={`${styles.sidebar} ${
          isSidebarOpen ? styles.open : styles.closed
        }`}
      >
        <div className={`${styles.logo} mb-md-3`}>
          <img
            src={HotelProLogo}
            alt="Hotel Pro Logo"
            className={`${styles.logoImage}`}
          />
          <span className={`${styles.logoText} d-none d-md-block`}>
            Hotel PRO
          </span>
        </div>
        <nav className={styles.navigation}>
          {sidebarItems.map(
            (item, index) =>
              (role === 'manager' || // Allow manager to access everything
                (item.allowedRoles && item.allowedRoles.includes(role))) && ( // Only render if the user's role is allowed
                <div key={index} className={styles.menuItem}>
                  <div
                    className={`${styles.sidebarItem} ${
                      activeItem === item.path || openDropdown === item.label
                        ? styles.active
                        : ''
                    }`}
                    onClick={() => handleClick(item)}
                  >
                    <img
                      src={item.icon}
                      alt={`${item.label} icon`}
                      className={styles.sidebarIcon}
                    />
                    <span className={styles.sidebarLabel}>{item.label}</span>
                    {item.dropdown && (
                      <span className={styles.dropdownArrow}>▼</span>
                    )}
                  </div>
                  {item.dropdown && openDropdown === item.label && (
                    <div className={styles.dropdownMenu}>
                      {item.dropdown.map(
                        (subItem, subIndex) =>
                          (role === 'manager' || // Allow manager to access everything
                            (subItem.allowedRoles &&
                              subItem.allowedRoles.includes(role))) && ( // Only render if the user's role is allowed
                            <div
                              key={subIndex}
                              className={`${styles.sidebarItem} ${
                                activeItem === subItem.path
                                  ? styles.activeDropdown
                                  : ''
                              }`}
                              onClick={() => handleClick(subItem)}
                            >
                              <img
                                src={subItem.icon}
                                alt={`${subItem.label} icon`}
                                className={styles.sidebarIcon}
                              />
                              <span className={styles.sidebarLabel}>
                                {subItem.label}
                              </span>
                            </div>
                          )
                      )}
                    </div>
                  )}
                </div>
              )
          )}
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
